"use client"
import { calculateDataUserPayload } from "@/services/Methods/checkoutPayloads";
import { _productPayload } from "@/services/Methods/commonPayload";
import localStorageCall from "@/services/Methods/localstorage.hook";
import { ContextData, storeAssigned, _getPrice, _pointsPrice, _getCvValue, _scrollToUp } from "@/services/Methods/normalMethods";
import { _getWebCatId, getAllProductApi, getAllProductApiPagination } from "@/services/Redux/Reducer/AllProductSlice";
import { CalculateLiteApi } from "@/services/Redux/Reducer/CheckoutSlice";
import _, { ceil } from "lodash";
import { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { setCalculateData, resetCalculateLiteData } from "@/services/Redux/Reducer/CheckoutSlice";

const withProductHOC = (Component, section) => {
    const WithProductHOComponent = (props) => {

        const data = useContext(ContextData);
        const dispatch = useDispatch();
        const { params, rankUpgrad, activeStep, setpActive } = props;
        const { addToCartProducts, pathname, setAddToCartProduct, setOpenMiniCart, searchParams, isScrolled, setIsScrolled, } = data;
        const [selectedCategory, setSelectedCategory] = useState(+(_getWebCatId('All Products')));
        const [bvPriceType, setBvPriceType] = useState(1);
        const [currentPriceType, setCurrentPriceType] = useState();


        const { calculateLiteData } = useSelector((state) => (state.CheckoutSlice));
        const Action = sessionStorage.getItem('action');

        const priceTypeCalled = useRef(false);

        const prevPriceType = useRef();

        // const updatePriceTime=useRef(null);

        console.log("prevPriceType.currentprevPriceType.currentprevPriceType.current", prevPriceType.current);

        useEffect(() => {
            const currentPriceType = calculateLiteData?.data?.crmOrder?.priceType;
            if (
                currentPriceType &&
                addToCartProducts?.normalProducts?.length &&
                prevPriceType.current !== currentPriceType
            ) {
                _onCalculateLiteApiCall(addToCartProducts.normalProducts, 'normal');
                prevPriceType.current = currentPriceType; // update

                setCurrentPriceType(currentPriceType)
            }
        }, [calculateLiteData?.data?.crmOrder?.priceType, addToCartProducts]);

        // currentPriceType




        console.log("sectionsection**************", section);


        useEffect(() => {
            const PRODUCTS = addToCartProducts?.normalProducts || [];

            if (PRODUCTS.length === 0) {
                dispatch(resetCalculateLiteData()); // clears the lite data
            }
        }, [addToCartProducts]);

        console.log("bvPriceTypebvPriceTypebvPriceType", bvPriceType, "calculateLiteData", calculateLiteData?.data?.crmOrder?.priceType);

        const CATEGORIES = [
            { name: "All Products", id: _getWebCatId('All Products') },
            // { name: "Enrollment", id: _getWebCatId('Enrollment') },
            { name: "Skincare", id: _getWebCatId('Skincare') },
            { name: "Body Care", id: _getWebCatId('Bodycare') },
            { name: "Hair Care", id: _getWebCatId('Haircare') },
            { name: "Daily Wellness & Foundational Nutrition", id: _getWebCatId('Daily Wellness & Foundational Nutrition') },
            { name: "Sports & Fitness", id: _getWebCatId('Sports & Fitness') },
            { name: "Digestive Health", id: _getWebCatId('Digestive Health') },
            { name: "Immune Support", id: _getWebCatId('Immune Support') },
            { name: "Mood Support & Wellbeing", id: _getWebCatId('Mood Support & Wellbeing') },
            { name: "Weight Management", id: _getWebCatId('Weight Management') },
            { name: "Beauty & Skin Health", id: _getWebCatId('Beauty & Skin Health') },
            { name: "Energy & Mental Performance", id: _getWebCatId('Energy & Mental Performance') },
            { name: "Women’s Health", id: _getWebCatId('Women’s Health') },
            { name: "Men’s Health", id: _getWebCatId('Men’s Health') },
            { name: "Sexual Wellness", id: _getWebCatId('Sexual Wellness') },

            // { name: "Nutrition", id: _getWebCatId('Nutrition') },
            // { name: "Club ViÁgo", id: _getWebCatId('Club Viago') },

        ];
        const itemId = searchParams?.get('itemId');
        const memoRizedSelector = createSelector(
            state => state?.AllProductSlice,
            (productState) => ({
                loading: productState?.isLoading
            })
        )
        const { loading } = useSelector((state) => memoRizedSelector(state))

        const [allProductState, setAllProductState] = useState([]);
        const [onlyAllProductsData, setOnlyAllProductsData] = useState([]);
        const [AllOthersProducts, setAllOtherProducts] = useState([]);
        const [packProducts, setPackProducts] = useState([]);
        const [category, setCategory] = useState("All Products");
        const [offset, setOffSet] = useState(1);
        const [totalRecords, setTotalRecords] = useState(0);
        const [searchText, setSearchText] = useState("");
        const [sortOrder, setSortOrder] = useState('sort');
        const [oldPriceTypeProducts, setOldPriceTypeProducts] = useState([])

        useEffect(() => {
            if (itemId) {
                const seachItem = searchParams?.get('search');
                if (seachItem) {
                    setSearchText(seachItem);
                }
                setSelectedCategory(+itemId)
                _getPorductAccordingSection(+itemId, 0, seachItem);
            }
            else {
                _getPorductAccordingSection(_.includes(pathname, 'main-enrollment') ?
                    _getWebCatId(activeStep === 0 && setpActive === 0 ? 'Step1Enrollment' : activeStep === 0 && setpActive === 1 ? 'Step2Enrollment' : activeStep === 1 ? 'Step3Enrollment' : 'Enrollment')
                    : selectedCategory, 0);
            }
            setOffSet(1);
        }, [section, selectedCategory, itemId, _getWebCatId, setpActive]);
        useEffect(() => {
            if (calculateLiteData?.data?.crmOrder?.priceType) {
                setBvPriceType(calculateLiteData.data.crmOrder.priceType);
            }
        }, [calculateLiteData]);

        useEffect(() => {
            if ((bvPriceType !== calculateLiteData?.data?.crmOrder?.priceType) || searchText) {
                console.log("inside-the-if-conditton");
                setCurrentPriceType(calculateLiteData?.data?.crmOrder?.priceType);

                setSearchText('');
                _getPorductAccordingSection(selectedCategory, 0);
            } else {
                setCurrentPriceType(calculateLiteData?.data?.crmOrder?.priceType);


                console.log('inside-the-else-value');

                let ProductData = _.compact(_.map(AllOthersProducts, (row) => {
                    let CONDITION = calculateLiteData?.data?.crmOrder?.priceType ? _getPrice(row, calculateLiteData?.data?.crmOrder?.priceType) : _.includes(['prospect'], CUSTOMER_TYPE?.role) ? _getPrice(row, 4) : _.includes(['company'], CUSTOMER_TYPE?.role) ? _getPrice(row, 3) : _.includes(['Professional'], CUSTOMER_TYPE?.customerSubTypeDescr) ? _getPrice(row, 5) : _.includes(['Executive'], CUSTOMER_TYPE?.customerSubTypeDescr) ? _getPrice(row, 4) : _.includes(['Partner'], CUSTOMER_TYPE?.customerSubTypeDescr) ? _getPrice(row, 3) : (_.includes(['Associate'], CUSTOMER_TYPE?.customerSubTypeDescr) || _.includes(pathname, 'distributor')) ? _getPrice(row, 2) : _getPrice(row, 1);
                    if (CONDITION || (CONDITION === 0)) {
                        if (row?.itemPricing.find(data => data?.countryCode.toLowerCase() === storeAssigned())) {

                            return _ProductStructure(row);
                        }
                    }
                }));
                setAllProductState(ProductData);
            }
        }, [calculateLiteData, addToCartProducts]);
        // console.log("selectedCategory", selectedCategory);

        function _getPorductAccordingSection(categoryVal, currentPage = offset - 1, searchData = "", callback = null, sortingPara = "") {
            dispatch(getAllProductApiPagination(currentPage, categoryVal, (data, totalProducts) => {
                const CUSTOMER_TYPE = localStorageCall().getItem('customerTypeDescr');
                setTotalRecords(totalProducts);

                let ProductData = _.compact(_.map(data, (row) => {
                    const SECTION_USE = rankUpgrad ? rankUpgrad : (CUSTOMER_TYPE?.role && section === 'normal') ? CUSTOMER_TYPE?.role : section;
                    let CONDITION = calculateLiteData?.data?.crmOrder?.priceType ? _getPrice(row, calculateLiteData?.data?.crmOrder?.priceType) : _.includes(['prospect'], CUSTOMER_TYPE?.role) ? _getPrice(row, 4) : _.includes(['company'], CUSTOMER_TYPE?.role) ? _getPrice(row, 3) : _.includes(['Professional'], CUSTOMER_TYPE?.customerSubTypeDescr) ? _getPrice(row, 5) : _.includes(['Executive'], CUSTOMER_TYPE?.customerSubTypeDescr) ? _getPrice(row, 4) : _.includes(['Partner'], CUSTOMER_TYPE?.customerSubTypeDescr) ? _getPrice(row, 3) : (_.includes(['Associate'], CUSTOMER_TYPE?.customerSubTypeDescr) || _.includes(pathname, 'distributor')) ? _getPrice(row, 2) : _getPrice(row, 1);

                    console.log("CONDITION", CONDITION);

                    if (CONDITION || (CONDITION === 0)) {
                        if (row?.itemPricing.find(data => data?.countryCode.toLowerCase() === storeAssigned())) {

                            return _ProductStructure(row);
                        }
                    }
                }));
                let OldProductData = _.compact(_.map(data, (row) => {
                    let CONDITION = _getPrice(row, 2);
                    if (CONDITION || (CONDITION === 0)) {
                        if (row?.itemPricing.find(data => data?.countryCode.toLowerCase() === storeAssigned())) {

                            return _ProductStructureOld(row);
                        }
                    }
                }));
                setOldPriceTypeProducts(OldProductData)

                if (callback) {
                    callback(ProductData, categoryVal);
                } else {
                    if (categoryVal !== 1000 && ProductData?.length === 0 && searchData) {
                        _getPorductAccordingSection(_getWebCatId('All Products'), 0, searchData, (products, catID) => {
                            if (catID === 1000 && products?.length > 0 && searchData) {
                                setAllProductState(products);
                                // router.push(`/${storeAssigned()}/products?itemId=1000&search=${searchData}`)
                            } else {
                                setAllProductState(ProductData);
                            }
                        });
                    } else {
                        setAllProductState(ProductData);
                    }
                }
                if (category === "All Products") {
                    setOnlyAllProductsData(ProductData)
                }
                setAllOtherProducts(data);
            }, searchData, (sortingPara || sortOrder), rankUpgrad));

        }

        function _onCalculateLiteApiCall(ADD_PRODUCTS, sec) {

            const effectivePriceType = prevPriceType.current || null;

            console.log("secsec***************", sec)


            console.log("effectivePriceTypeeffectivePriceType", effectivePriceType);

            console.log("calculateLiteData?.data?.crmOrder?.priceTypenewwwwwwwww", calculateLiteData?.data?.crmOrder?.priceType, "currentPriceType", prevPriceType.current)
            const selectedShippingOption = {
                section: 'normal',
                autoshipSelectedShipping: { shipCarrierId: null, shipMethodType: null },
                oneTimeSelectedShipping: { shipCarrierId: null, shipMethodType: null }
            };
            const useDefaultAddressOrNot = { bypassOrNot: true, addessData: null };

            let calculteDataUser = calculateDataUserPayload(null, selectedShippingOption, useDefaultAddressOrNot?.bypassOrNot);
            const detailsArray = _productPayload(ADD_PRODUCTS);
            calculteDataUser["details"] = detailsArray;
            calculteDataUser['country'] = _.upperCase(storeAssigned());
            calculteDataUser["lastName"] = 'Bhip';
            const CUSTOMER_TYPE = localStorageCall().getItem('customerTypeDescr');
            calculteDataUser["priceType"] = calculateLiteData?.data?.crmOrder?.priceType ? calculateLiteData?.data?.crmOrder?.priceType : prevPriceType.current ? prevPriceType.current : currentPriceType ? currentPriceType : _.includes(['prospect'], CUSTOMER_TYPE?.role) ? 4 : _.includes(['company'], CUSTOMER_TYPE?.role) ? 3 : _.includes(['Professional'], CUSTOMER_TYPE?.customerSubTypeDescr) ? 5 : _.includes(['Executive'], CUSTOMER_TYPE?.customerSubTypeDescr) ? 4 : _.includes(['Partner'], CUSTOMER_TYPE?.customerSubTypeDescr) ? 3 : (_.includes(['Associate'], CUSTOMER_TYPE?.customerSubTypeDescr) || sec === 'distributor') ? 2 : 1
            dispatch(CalculateLiteApi(calculteDataUser, (data) => console.log("ErrorData", data)));
        }

        const debouncedApiCall = useRef(_.debounce((products, sec) => {
            _onCalculateLiteApiCall(products, sec);
        }, 2000)).current;

        function _onPaginationChange(e) {
            const selectedPage = e.selected;
            const offsetpage = selectedPage + 1;
            setOffSet(offsetpage)
            _getPorductAccordingSection(selectedCategory, offsetpage - 1);
            _scrollToUp();
        }
        function _addToCartFunction(id, frequency = "oneTime", category_id = "", section = "normal") {
            console.log("_addToCartFunction", id, "category_id", category_id, "section", section);
            const PRODUCTS = addToCartProducts?.[section + 'Products'] || [];

            const FIND_PRODUCT = _.find(allProductState, { id });
            const AmbassadorRenewalProduct = _.find(allProductState, { title: "Ambassador Renewal Fee " });
            const FIND_ALREADY_PRODUCT = _.find(PRODUCTS, { id });
            let ADD_PRODUCTS = [];

            if (FIND_ALREADY_PRODUCT) {
                ADD_PRODUCTS = [..._.reject(PRODUCTS, FIND_ALREADY_PRODUCT), {
                    ...FIND_ALREADY_PRODUCT,
                    quantity: !_.includes(['main_enrollment'], rankUpgrad) ? FIND_ALREADY_PRODUCT?.quantity + FIND_PRODUCT?.quantity : 1,
                    category_id: category_id,
                    frequency: _.includes(["Ambassador Registration Fee"], FIND_ALREADY_PRODUCT?.title) ? 'member' : frequency
                }];
            } else {
                if (_.includes(["Ambassador Registration Fee"], FIND_PRODUCT?.title)) {
                    ADD_PRODUCTS = [...PRODUCTS, { ...FIND_PRODUCT, member: true, frequency: 'member' }];
                } else {
                    ADD_PRODUCTS = [...PRODUCTS, { ...FIND_PRODUCT, frequency }];
                }
            }

            _frequancyChange(id, frequency);
            console.log("sectionsectionsection", section);

            localStorageCall().setItem(String(section + 'Products'), JSON.stringify(ADD_PRODUCTS));
            localStorageCall().setItem('RenewalProduct', JSON.stringify([AmbassadorRenewalProduct]));
            setAddToCartProduct((prv) => ({ ...prv, [section + 'Products']: ADD_PRODUCTS }));
            setOpenMiniCart(true);
            if (ADD_PRODUCTS?.length > 0) {
                _onCalculateLiteApiCall(ADD_PRODUCTS, 'normal')
            }
        }




        function _addToCartFunctionCheck(id, isChecked, frequency = "oneTime", category_id = "") {
            const PRODUCTS = addToCartProducts[section + 'Products'] || [];
            const FIND_PRODUCT = _.find(allProductState, { id });
            const AmbassadorRenewalProduct = _.find(allProductState, { title: "Ambassador Renewal Fee " });
            const FIND_ALREADY_PRODUCT = _.find(PRODUCTS, { id });
            let ADD_PRODUCTS = [];

            if (isChecked) {
                // Add product to cart if checked
                if (FIND_PRODUCT) {
                    console.log("inside-the-already-inside-the-product*********************");

                    ADD_PRODUCTS = [
                        ..._.reject(PRODUCTS, FIND_PRODUCT),
                        {
                            ...FIND_PRODUCT,
                            quantity: !_.includes(['main_enrollment'], rankUpgrad)
                                ? FIND_PRODUCT.quantity
                                : 1, // Increase by 1 if not in rankUpgrad
                            category_id,
                            frequency: _.includes(["Ambassador Registration Fee"], FIND_PRODUCT.title)
                                ? 'member'
                                : frequency,
                        }
                    ];
                } else {
                    ADD_PRODUCTS = [...PRODUCTS, { ...FIND_PRODUCT, frequency, quantity: 1 }];
                }
            } else {
                // Remove product from cart if unchecked
                ADD_PRODUCTS = _.reject(PRODUCTS, { id });
            }

            // Update frequency
            _frequancyChange(id, frequency);

            // Update cart state
            setAddToCartProduct((prev) => ({
                ...prev,
                [section + 'Products']: ADD_PRODUCTS
            }));
            localStorageCall().setItem(String(section + 'Products'), JSON.stringify(ADD_PRODUCTS));

            // Keep renewal product separate
            setAddToCartProduct((prev) => ({
                ...prev,
                RenewalProduct: AmbassadorRenewalProduct ? [AmbassadorRenewalProduct] : []
            }));

            setOpenMiniCart(true);
            if (ADD_PRODUCTS?.length > 0) {
                _onCalculateLiteApiCall(ADD_PRODUCTS, 'distributor')
            }
        }


        //checkout products
        function _checkoutQuantityIncDec(id, section_qty, sec) {

            console.log("inside-the-increase-quantiy-function&&&&&&&&&&&&&&&&&&&&&&&&&",);


            const PRODUCTS = allProductState;

            console.log("PRODUCTSPRODUCTSPRODUCTS*******************", PRODUCTS);


            const FINDINDEX_LOCAL = _.findIndex(PRODUCTS, { id: id });

            const CART_PRODUCTS = addToCartProducts[section + 'Products'] || [];

            const FINDINDEX_FOR_CART = _.findIndex(CART_PRODUCTS, { id: id });

            console.log("CART_PRODUCTSCART_PRODUCTSCART_PRODUCTS", CART_PRODUCTS)


            const FINDPRODUCT_INSIDE_CART = _.find(CART_PRODUCTS, { id });

            console.log("inside-the-cart-product==================", FINDPRODUCT_INSIDE_CART);



            console.log("FINDINDEX_LOCALFINDINDEX_LOCALFINDINDEX_LOCAL", FINDINDEX_LOCAL);


            if (FINDINDEX_LOCAL > -1) {
                PRODUCTS[FINDINDEX_LOCAL]['quantity'] = (section_qty === "sub") ? ((PRODUCTS[FINDINDEX_LOCAL]?.quantity - 1 > 0) ? PRODUCTS[FINDINDEX_LOCAL]?.quantity - 1 : 1) : PRODUCTS[FINDINDEX_LOCAL]?.quantity + 1;
                setAllProductState([])
                setAllProductState(PRODUCTS);
                if (FINDINDEX_FOR_CART > -1 && _.includes(pathname, 'distributor')) {
                    CART_PRODUCTS[FINDINDEX_FOR_CART]['quantity'] = (section_qty === "sub") ? ((CART_PRODUCTS[FINDINDEX_FOR_CART]?.quantity - 1 > 0) ? CART_PRODUCTS[FINDINDEX_FOR_CART]?.quantity - 1 : 1) : CART_PRODUCTS[FINDINDEX_FOR_CART]?.quantity + 1;
                    setAddToCartProduct((prev) => ({
                        ...prev,
                        [section + 'Products']: CART_PRODUCTS
                    }));
                    localStorageCall().setItem(String(section + 'Products'), JSON.stringify(CART_PRODUCTS));
                    debouncedApiCall(CART_PRODUCTS, sec);
                }
            }

        }

        function _frequancyChange(id, autoshipType) {
            const PRODUCTS = allProductState;
            const FINDINDEX_LOCAL = _.findIndex(PRODUCTS, { id: id });
            if (FINDINDEX_LOCAL > -1) {
                // PRODUCTS[FINDINDEX_LOCAL]['autoshipType'] = autoshipType;
                PRODUCTS[FINDINDEX_LOCAL]['frequency'] = autoshipType;
                setAllProductState([])
                setAllProductState(PRODUCTS);
            }
        }

        function _ProductStructure(row) {
            const CUSTOMER_TYPE = localStorageCall().getItem('customerTypeDescr');
            const PriceType = calculateLiteData?.data?.crmOrder?.priceType ? calculateLiteData?.data?.crmOrder?.priceType : _.includes(['prospect'], CUSTOMER_TYPE?.role) ? 4 : _.includes(['company'], CUSTOMER_TYPE?.role) ? 3 : _.includes(['Professional'], CUSTOMER_TYPE?.customerSubTypeDescr) ? 5 : _.includes(['Executive'], CUSTOMER_TYPE?.customerSubTypeDescr) ? 4 : _.includes(['Partner'], CUSTOMER_TYPE?.customerSubTypeDescr) ? 3 : (_.includes(['Associate'], CUSTOMER_TYPE?.customerSubTypeDescr) || _.includes(pathname, 'distributor')) ? 1 : 1
            console.log("PriceTypePriceTypePriceType", PriceType);

            console.log("CUSTOMER_TYPECUSTOMER_TYPE", CUSTOMER_TYPE)
            // setBvPriceType(PriceType);
            let NORMAL_PRICEING = { oneTime: _getPrice(row, PriceType), autoship: _getPrice(row, PriceType) };
            return ({
                id: row?.itemId,
                itemId: row?.itemId,
                image: row?.mediumImage,
                title: row?.title,
                normal_oneTime: NORMAL_PRICEING?.oneTime || 0,
                normal_autoship: NORMAL_PRICEING?.autoship || 0,
                retail_oneTime: _getPrice(row, PriceType) || 0,
                retail_autoship: _getPrice(row, PriceType) || 0,
                customer_oneTime: _getPrice(row, PriceType) || 0,
                customer_autoship: _getPrice(row, PriceType) || 0,
                distributor_oneTime: _getPrice(row, PriceType) || 0,
                distributor_autoship: _getPrice(row, PriceType) || 0,
                cv_oneTime: _getCvValue(row, 3),
                cv_autoship: _getCvValue(row, 3),
                quantity: 1,
                itemCode: row?.fullItemCode,
                isEligibleForAutoOrder: row?.isEligibleForAutoOrder,
                stock: "",
                points: _pointsPrice(row?.itemPricing, 'oneTime', row?.isEligibleForAutoOrder),
                autoshipType: 'oneTime',
                frequency: Action === "smartsave" ? "autoship" : 'oneTime',
                description1: row?.otherFields?.longField1,
                description2: row?.otherFields?.longField2,
                out_of_stock: row?.otherFlags?.flag10,
                category_id: _.includes(pathname, 'main-enrollment') ? _getWebCatId('Enrollment') : selectedCategory,
                product_content: row?.otherFields?.longField1 || ''
            })
        }

        function _ProductStructureOld(row) {
            const PriceType = 2;
            let NORMAL_PRICEING = { oneTime: _getPrice(row, PriceType), autoship: _getPrice(row, PriceType) };
            return ({
                id: row?.itemId,
                itemId: row?.itemId,
                image: row?.mediumImage,
                title: row?.title,
                normal_oneTime: NORMAL_PRICEING?.oneTime || 0,
                normal_autoship: NORMAL_PRICEING?.autoship || 0,
                retail_oneTime: _getPrice(row, PriceType) || 0,
                retail_autoship: _getPrice(row, PriceType) || 0,
                customer_oneTime: _getPrice(row, PriceType) || 0,
                customer_autoship: _getPrice(row, PriceType) || 0,
                distributor_oneTime: _getPrice(row, PriceType) || 0,
                distributor_autoship: _getPrice(row, PriceType) || 0,
                cv_oneTime: _getCvValue(row, 3),
                cv_autoship: _getCvValue(row, 3),
                quantity: 1,
                itemCode: row?.fullItemCode,
                isEligibleForAutoOrder: row?.isEligibleForAutoOrder,
                stock: "",
                points: _pointsPrice(row?.itemPricing, 'oneTime', row?.isEligibleForAutoOrder),
                autoshipType: 'oneTime',
                // frequency: 'oneTime',
                frequency: Action === "smartsave" ? "autoship" : 'oneTime',
                description1: row?.otherFields?.longField1,
                description2: row?.otherFields?.longField2,
                out_of_stock: row?.otherFlags?.flag10,
                category_id: _.includes(pathname, 'main-enrollment') ? _getWebCatId('Enrollment') : selectedCategory,
                product_content: row?.otherFields?.longField1 || ''
            })
        }

        return <Component {...props} {...{
            allProductState, setAllProductState, onlyAllProductsData, setOnlyAllProductsData, loading, CATEGORIES, selectedCategory, setSelectedCategory,
            _addToCartFunction, _ProductStructure, _frequancyChange, _checkoutQuantityIncDec,
            _getPorductAccordingSection, setCategory, category,
            section: rankUpgrad === 'prospect' ? rankUpgrad : section,
            packProducts, isScrolled, setIsScrolled,
            _quantityIncOrDec: _checkoutQuantityIncDec,
            _onPaginationChange, offset, setOffSet, totalCount: ceil(totalRecords / 10),
            searchText, setSearchText, setSortOrder, sortOrder, setAllOtherProducts, AllOthersProducts, _addToCartFunctionCheck,
            oldPriceTypeProducts, _onCalculateLiteApiCall

        }} />
    }

    return WithProductHOComponent;
}

export default withProductHOC;